module.exports = __webpack_public_path__ + "static/media/Not Found.bde56710.svg";